<template>
  <!-- #region template -->
  <b-container fluid>
    <p>Dev</p>
  </b-container>
  <!-- #endregion -->
</template>

<script>
// #region import
import { mapActions } from 'vuex'
import { getApp } from 'firebase/app'
import { getFirestore, collection, getDocs, updateDoc, doc } from 'firebase/firestore'
import { getStorage, ref as storageRef, ref, listAll, getDownloadURL } from 'firebase/storage'
// #endregion

// #region export
export default {
  name: 'Development',
  data() {
    return {}
  },
  created() {
    // this.test()
  },
  methods: {
    // #region mapActions
    ...mapActions(['populateDocument', 'firestore/addDocs', 'firestore/addDoc', 'firestore/updateDoc', 'firestore/getDoc', 'firestore/getDocs', 'firestore/updateDoc']),
    // #endregion
    async test() {
      try {
        // const blueprint = await this['firestore/getDoc']({
        //   path: '_blueprints/w28raF7U6DUPgtq58kF6',
        // })
        // let searhables = {}
        // blueprint.form.tabs.forEach((tab) => {
        //   tab.elements.forEach((element) => {
        //     searhables[element.key] = element.searchable
        //   })
        // })
        // console.log(searhables)
        // const options = await this['firestore/getDocs']({
        //   path: 'options',
        // })
        // for (let i = 0; i < options.length; i++) {
        //   let document = options[i]
        //   let updatedFields = {}
        //   let __search_query = ''
        //   for (let key in searhables) {
        //     if (searhables[key] && document.hasOwnProperty(key)) {
        //       __search_query += document[key] + ' '
        //     }
        //   }
        //   if (__search_query != '') {
        //     updatedFields.__search_query = __search_query.trim()
        //   }
        //   if (Object.keys(updatedFields).length > 0) {
        //     await this['firestore/updateDoc']({
        //       path: 'options/' + document._reference.id,
        //       data: updatedFields,
        //     })
        //   }
        // }
      } catch (error) {
        console.error('Error:', error)
      }
    },
  },
}
// #endregion
// #endregion
</script>

<style lang="scss"></style>
